"use client"

import { useState } from "react"
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { FileText } from "lucide-react"

export default function AddDocument({update}) {
  const [formData, setFormData] = useState({
    documentName: "",
    description: "",
    assignedBy: "",
    assignedFor: "",
  })

  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    setTimeout(() => {
      console.log("Document Type Data:", formData)
      alert("Document type added successfully!")
      // Reset form
      setFormData({
        documentName: "",
        description: "",
        assignedBy: "",
        assignedFor: "",
      })
      setLoading(false)
    }, 1500)
  }

  const handleCancel = () => {
    setFormData({
      documentName: "",
      description: "",
      assignedBy: "",
      assignedFor: "",
    })
  }

  return (

      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10" xs="12">
            {/* Header Section */}
            <div className="mb-8">
             {update?( <h1 className="text-4xl font-bold text-black mb-2">Update Document Type</h1>): <h1 className="text-4xl font-bold text-black mb-2">Add Document Type</h1>}
              <p className="text-black text-lg">Create and manage document types in your organization</p>
            </div>

            {/* Main Form Card */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <Form onSubmit={handleSubmit}>
                {/* Document Info Icon Section */}
                <div className="mb-4 pb-4 border-b border-gray-200">
                  <div className="d-flex gap-3 align-items-center">
                    <div
                      className="bg-gray-100 rounded-lg p-3 d-flex align-items-center justify-content-center"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <FileText size={24} className="text-black" />
                    </div>
                    <div>
                      <p className="text-black font-semibold mb-0">Document Type Details</p>
                      <p className="text-black text-sm mb-0">Define document categories and permissions</p>
                    </div>
                  </div>
                </div>

                {/* Document Name Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="documentName" className="text-black font-semibold mb-2">
                        Document Name <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="documentName"
                        id="documentName"
                        placeholder="Enter document type name (e.g., Invoice, Agreement, Report)"
                        value={formData.documentName}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Description Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="description" className="text-black font-semibold mb-2">
                        Description <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Provide a detailed description of this document type"
                        value={formData.description}
                        onChange={handleInputChange}
                        required
                        rows={5}
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb", resize: "none" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Assigned By and Assigned For Row */}
                <Row className="mb-5">
                  <Col md="6">
                    <FormGroup>
                      <Label for="assignedBy" className="text-black font-semibold mb-2">
                        Assigned By <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="assignedBy"
                        id="assignedBy"
                        value={formData.assignedBy}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      >
                        <option value="">Select assigned by</option>
                        <option value="admin">Admin</option>
                        <option value="manager">Manager</option>
                        <option value="hr">Human Resources</option>
                        <option value="compliance">Compliance Officer</option>
                        <option value="legal">Legal Team</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="assignedFor" className="text-black font-semibold mb-2">
                        Assigned For <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="assignedFor"
                        id="assignedFor"
                        value={formData.assignedFor}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      >
                        <option value="">Select assigned for</option>
                        <option value="employees">Employees</option>
                        <option value="managers">Managers</option>
                        <option value="hr">HR Department</option>
                        <option value="finance">Finance Department</option>
                        <option value="clients">Clients</option>
                        <option value="vendors">Vendors</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-end pt-6 border-t border-gray-200">
                  <Button
                    type="button"
                    color="light"
                    className="px-6 py-2 font-semibold text-black border border-gray-300"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="dark"
                    className="px-6 py-2 font-semibold bg-black text-white"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>

            {/* Footer Info */}
            <div className="mt-6 text-center text-gray-500 text-sm">
              <p>
                All fields marked with <span className="text-red-500">*</span> are required
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    
  )
}
